import { render, staticRenderFns } from "./ChecklistItemComponent.vue?vue&type=template&id=584d73df&scoped=true&"
import script from "./ChecklistItemComponent.vue?vue&type=script&lang=js&"
export * from "./ChecklistItemComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistItemComponent.vue?vue&type=style&index=0&id=584d73df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584d73df",
  null
  
)

export default component.exports